import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { CadastroBensService, BensCadastrarPayload } from '../../services/cadastro-bens.service';
import { HeaderComponent } from '../../shared/header/header.component';

@Component({
  selector: 'app-cadastro-patrimonio',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, HttpClientModule, HeaderComponent],
  templateUrl: './cadastro-patrimonio.component.html',
  styleUrls: ['./cadastro-patrimonio.component.scss']
})
export class CadastroPatrimonioComponent implements OnInit {

  patrimonioForm!: FormGroup;

  marcas: any[] = [];
  categorias: any[] = [];
  modelos: any[] = [];
  condicoes: any[] = [];

  constructor(
    private fb: FormBuilder,
    private service: CadastroBensService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.patrimonioForm = this.fb.group({

      
      dadosBasicos: this.fb.group({
        exbePatrimonioId: [0],
        numeroDeSerie: [null, [Validators.required, Validators.min(1000)]],
        descricao: ['', Validators.required],
        usuarioCadastroId: [1]
      }),

      // ABA 2
      modelo: this.fb.group({
        id: [0],
        nome: ['', Validators.required],
        usuarioCadastroId: [1],

        categoria: this.fb.group({
          id: [null, Validators.required]
        }),

        marca: this.fb.group({
         id: [null], 
         nome: ['', Validators.required] 
    })
      }),
      
      condicao: this.fb.group({
        id: [null, Validators.required] 
      })
    });

    this.carregarCategorias();
    this.carregarCondicoes();
  }

  carregarCondicoes() {
    this.service.getCondicoes().subscribe({
      next: res => {
        this.condicoes = res;
        
        const condicaoPadrao = this.condicoes.find(c => c.nome === 'Novo');
        if (condicaoPadrao) {
            this.patrimonioForm.get('condicao.id')?.setValue(condicaoPadrao.id);
        } else if (this.condicoes.length > 0) {
             
             this.patrimonioForm.get('condicao.id')?.setValue(this.condicoes[0].id);
        }
      },
      error: err => console.error('Erro ao carregar condições', err)
    });
  }

  carregarCategorias() {
    this.service.getCategorias().subscribe({
      next: res => this.categorias = res
    });
  }

  onCategoriaChange() {
    const id = this.patrimonioForm.get('modelo.categoria.id')?.value;
    if (!id) return;

    this.service.getModelosPorCategoria(id).subscribe({
      next: res => this.modelos = res
    });
  }

  carregarMarcaSeExiste() {
    const nome = this.patrimonioForm.get('modelo.marca.nome')?.value; 
    if (!nome) return;

    this.service.getMarcaPorNome(nome).subscribe(
        m => {
            
            this.patrimonioForm.get('modelo.marca.id')?.setValue(m.id);
        },
        () => {
            
            this.patrimonioForm.get('modelo.marca.id')?.setValue(0);
        }
    );
}

  carregarModeloSeExiste() {
    const nome = this.patrimonioForm.get('modelo.nome')?.value;
    if (!nome) return;

    this.service.getModeloPorNome(nome).subscribe(m => {
      this.patrimonioForm.patchValue({
        modelo: {
          id: m.id,
          categoria: { id: m.categoriaId },
          marca: { id: m.marcaId }
        }
      });
    });
  }

  

  onSubmit() {
    if (this.patrimonioForm.invalid) {
      this.patrimonioForm.markAllAsTouched();
      this.toastr.error('Preencha todos os campos.');
      return;
    }

    const formValue = this.patrimonioForm.getRawValue();

    const payload: BensCadastrarPayload = {
      exbePatrimonioId: formValue.dadosBasicos.exbePatrimonioId,
      numeroDeSerie: formValue.dadosBasicos.numeroDeSerie,
      descricao: formValue.dadosBasicos.descricao,
      usuarioCadastroId: formValue.dadosBasicos.usuarioCadastroId,
      status: true,
      idCategoria: formValue.modelo.categoria.id,
      condicaoBemId: formValue.condicao.id,

      marcaCadastrar: {
        id: formValue.modelo.marca.id, 
        nome: formValue.modelo.marca.nome,       
      },

      modeloCadastrar: {
        id: formValue.modelo.id,
        nome: formValue.modelo.nome,
        usuarioCadastroId: formValue.dadosBasicos.usuarioCadastroId,
        categoriaCadastrar: formValue.modelo.categoria.id,
        marcaCadastrar: formValue.modelo.marca.id
      }
    };

    this.service.cadastrarBens(payload).subscribe({
      next: () => {
        this.toastr.success('Bem cadastrado com sucesso!');
        this.patrimonioForm.reset();
      },
      error: (err) => {
        this.toastr.error('Erro ao cadastrar bem');
        console.error(err);
      }
    });
  }
}